var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2662",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2662",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAERklEQVRoge1ZZ2gVQRAeC7ZYoojlhxKNFSUIEjU/jCCiiA0LlhhNUQSNP2yRSIJojAWCjSAWVFRsqAFFMaiRKAb8IRK7kgRjwYIN1KBin3HvvLnLXnl3+94TyQcfPG5nZ7+53Zud3QdQj/8TXZF7kM+Qb5AlyCFRVRQCeiJfIX9Z+AU5Moq6POMy1BWv8xGyadSUecBwML/xZGQ35HP2fH7U1HlAGRhCt7Hni9jzx8gmkZfmjiQwRH5FxrG2ZmCehcxIi/OCc2AI3C1pX87aq5GNIyfNHQORP0GI+w4iE1kRg3wNRhAzI6bOBQ2QF8EQdsDBNo/ZVSKbh12dB8wD89rv42DbBvmW2ReGXZ0LxoNIl7qg1R76zGb2tOyWhU2dA9oiN4NY77qYm+A9PZ5m/YiHkF3UyxSgbNEdRBmwEFmM/GARQOI7huCTPujzFh80k5TJspFjQCzFkHdtytfTkUUgCrAqEOvarjQgnkW2C3UgTdxeMLKXjD9AlB+lyJ3IDBDfkRQ9QGQGJ7Gct5BjPQil2VsMoqSQgarUKy6BcFKFO8jqpBHyrk0HcvwUeQnEBrVAE+UV1Zqf+y52nZBpyO0gltdDMH9jnC+QLXnnEayR1ncucgKyP4hlFQR6AFU++lJS6IUcDWIWXzKdc7lhFmvYEUCsDPHIJRDarNmBlyMbecMk1lCD7KBgMNWgXbscDJ0reGMLMNcpd+DfCoLEXwDzjh9vNaJ19g3MQdjldqp/UpAztN/hhFU8McvOeAqYg3iA7CyxS2U209TqNUEmPs+tk5cgeACpPsVR3VQL9vWTL/E6poI5iNvIVqydlg3V8yngfwl91nx/lLTRvlQCZvE5oQ5gDeJYALEy5IOYgXxJ21oIKF4HvWW+xaf7dRQChlrGXBXU4Sbm7B4EnwW3DHaGjXdKwXh/Sl9+ihoV0J9TBqOCUn/7tHzjAo71F4Vs0HUOdlRxVmq0qz6dMlgGazsZQG8dTGSOSxzscpid3VHRKYMVeejvCwnMcYWDHb31Ko12M+CE42ycyT762yKROS5X6diC/WycFJWOx4G3JRQUW9k4S1U6zmWOt6h0bAE/l+xT6fgoczxHpWMLktk411U65uflRJWOLYgFYx+gaxYlF8B0/aFfrdA1R4yLPbVTHUWVI10C0H9lK0F8lLEexnsCxsvq60+yGQOYQ6eDeW8QNwrvmb2Vn5AHkYMd/PBSQslZYxZzWCxpp7MCXQTwytWNtExOgAjaivXMbo2KALKZww3seWttgFqJwBtaG33w9G8MlcxXJXYUNAXPD0yZrH2XigDSmEOqcWhPoBwt+yuVrgCTHHz1Qx6Burdw9BIKtL5l7HmBigDaI99JxHJSeRFKlUr/6JS6+KRbuQQVARDoDlQ/AnLWgCjMGvr0S0FXSPwq34kJdLNGt2F0BU4fYDqo+dOagqeLNUoQ15CHkcMU+K1HRPAbik3FkNFUEJkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.b30374ec7d01475ff9ddedc53bd44237.svg";
export { ForwardRef as ReactComponent };